import { useEffect, useState } from "react";
import { api, INR2 } from "@/lib/api";

export default function LiveRateTicker() {
  const [rate, setRate] = useState(null);
  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const { data } = await api.get("/market/price");
        if (mounted) setRate(data);
      } catch (e) {}
    };
    load();
    const t = setInterval(load, 30000);
    return () => { mounted = false; clearInterval(t); };
  }, []);
  const up = (rate?.change_pct_24h || 0) >= 0;
  return (
    <div
      data-testid="live-rate-ticker"
      className="flex items-center gap-3 rounded-full bg-brand-sand border border-brand-line-faint px-3.5 py-2 shadow-soft"
    >
      <span className="relative inline-flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full rounded-full bg-brand-secondary opacity-70 animate-pulse-dot" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-secondary" />
      </span>
      <span className="text-[10px] uppercase tracking-[0.2em] text-brand-slate">Live</span>
      <div className="flex items-center gap-3 text-xs">
        {[
          ["24k", rate?.price_24k_inr_per_gram],
          ["22k", rate?.price_22k_inr_per_gram],
        ].map(([k, v]) => (
          <div key={k} className="flex items-center gap-1">
            <span className="text-brand-slate">{k}</span>
            <span className="font-semibold tabular-nums text-brand-cream">
              {v ? INR2(v) : "—"}
            </span>
          </div>
        ))}
      </div>
      <div className={`ml-auto text-[10px] font-semibold tabular-nums px-2 py-0.5 rounded-full ${up ? "text-brand-secondary bg-emerald-900/25" : "text-brand-danger bg-red-900/25"}`}>
        {up ? "▲" : "▼"} {rate ? Math.abs(rate.change_pct_24h) : 0}%
      </div>
    </div>
  );
}
